/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, ButtonProps, Menu, MenuProps } from '@mantine/core'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'

export type QuickMenuProps = MenuProps & {
  buttonProps?: ButtonProps,
  icon?: IconProp,
  label?: string
}

function QuickMenu (props: QuickMenuProps) {
  const {
    buttonProps,
    children,
    icon = faBars,
    label,
    ...others
  } = props
  return (
    <Menu {...others}>
      <Menu.Target>
        <Button {...buttonProps}>
          <FontAwesomeIcon
            fixedWidth
            icon={icon}
          />
          {label}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {children}
      </Menu.Dropdown>
    </Menu>
  )
}

export default QuickMenu
